var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDropdownParagraph(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "convert to"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 4.375C3.25 4.09886 3.47386 3.875 3.75 3.875H10H16.25C16.5261 3.875 16.75 4.09886 16.75 4.375V6.875C16.75 7.15114 16.5261 7.375 16.25 7.375C15.9739 7.375 15.75 7.15114 15.75 6.875V4.875H10.5V15.125H12.5C12.7761 15.125 13 15.3489 13 15.625C13 15.9011 12.7761 16.125 12.5 16.125H10H7.5C7.22386 16.125 7 15.9011 7 15.625C7 15.3489 7.22386 15.125 7.5 15.125H9.5V4.875H4.25V6.875C4.25 7.15114 4.02614 7.375 3.75 7.375C3.47386 7.375 3.25 7.15114 3.25 6.875V4.375Z",
    fill: "#868E96"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownParagraph);
export default __webpack_public_path__ + "static/media/dropdown-paragraph.53d68a21cf60413d30519521ba3596e2.svg";
export { ForwardRef as ReactComponent };